import * as React from 'react' // DEPRECATED. Please use 'react-responsive'.

class MatchMedia extends React.PureComponent<any, { matches: boolean }> {
  state = {
    matches: false,
  }
  mediaQueryList = null

  componentDidMount() {
    if (typeof window !== 'object' || !window.matchMedia) return
    const { media } = this.props
    this.mediaQueryList = window.matchMedia(media)
    this.mediaQueryList.addListener(this.onMediaChange)

    if (this.mediaQueryList.matches) {
      this.onMediaChange()
    }
  }

  componentWillUnmount() {
    this.mediaQueryList.removeListener(this.onMediaChange)
    this.mediaQueryList = null
  }

  onMediaChange = () => {
    this.setState({
      matches: this.mediaQueryList.matches,
    })
  }

  render() {
    const { children } = this.props
    const { matches } = this.state

    if (typeof children === 'function') {
      return children(matches)
    }

    return matches ? children : null
  }
}

export default MatchMedia
